var map = {
	"./applePay.svg": 3534,
	"./attention.svg": 9600,
	"./back.svg": 610,
	"./caution.svg": 6363,
	"./check-large.svg": 3533,
	"./check-outline.svg": 9899,
	"./check.svg": 9354,
	"./chevron-bottom-16x16.svg": 5816,
	"./chevron-bottom-white.svg": 4798,
	"./chevron-bottom.svg": 6292,
	"./clear.svg": 9320,
	"./close.svg": 2697,
	"./exit.svg": 2898,
	"./gift.svg": 4344,
	"./hide.svg": 1338,
	"./login.svg": 1935,
	"./masterCard.svg": 4342,
	"./pen.svg": 7446,
	"./phone.svg": 5832,
	"./plus.svg": 1689,
	"./profile.svg": 7236,
	"./scan.svg": 1460,
	"./show.svg": 4278
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6924;